import { render, staticRenderFns } from "./NSIMonitor.vue?vue&type=template&id=233a3172&scoped=true&"
import script from "./NSIMonitor.vue?vue&type=script&lang=js&"
export * from "./NSIMonitor.vue?vue&type=script&lang=js&"
import style0 from "./NSIMonitor.vue?vue&type=style&index=0&id=233a3172&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a3172",
  null
  
)

export default component.exports